import ButtonApi from '../../../../components/ButtonApi';
import { useMint } from './MintNftProvider';

const Step1 = () => {
  const [{ isDisabled, chainName, onNext }] = useMint();

  return (
    <>
      <h2>WELCOME SIRE</h2>
      <p>Your XION identity building journey starts here. Completing rituals makes you stronger in this path. As you progress you send out an echo across all lands stating, you "believed in something".</p>
      <ButtonApi className='primary' onClick={onNext} disabled={isDisabled}>
        Start Now
      </ButtonApi>
    </>
  );
};

export default Step1;
